export const UPGRADE_EMAIL = 'upgrade@codioimpact.com';
